export default __webpack_public_path__ + "static/media/additionalInfo.8625c12b.svg";